import {initFiltersListeners} from '@js/modules/public/organizations/index/filtersPanel';
import {LocalStorage} from '@js/LocalStorage';
import Notifier from '@js/components/Notifier';
import {routes} from '@js/helpers/routes';
import {sendRequest} from '@js/utils';

$(() => {
    initFiltersListeners();
    initFavoritesOrganization('.favorite');
    $('body').on('click', '.favorite', async (e) => {
        e.preventDefault();
        const $currentItem = $(e.currentTarget);
        const dataId = $currentItem.attr('data-id');
        const isAdd = await addDeleteFavorites(dataId, window.isLogged);
        changeFavoriteElement($currentItem, isAdd, dataId);
    });
});

export function initFavoritesOrganization(purposeElements) {
    const $favoritesOrganizations = $('body').find(purposeElements);
    const organizations = [];
    $favoritesOrganizations.map((key) => {
        const organizationId = $($favoritesOrganizations[key]).attr('data-id');
        const isExist = checkOrganizationInFavoriteList(organizationId);
        if (isExist) {
            changeFavoriteElement($favoritesOrganizations[key], true, organizationId);
            if (window.isLogged) {
                organizations.push(organizationId);
                addDeleteFavorites(organizationId);
            }
        }
    });
    saveFavoriteOrganizationsFromStorage(organizations);
}

export function saveFavoriteOrganizationsFromStorage(organizations) {
    if (organizations.length > 0) {
        const location = routes.lk.abitur.favoriteOrganizations.save();
        const notifier = new Notifier();
        sendRequest('post', `${location}`, {
            _token: $('meta[name="csrf-token"]').attr('content'),
            organizations,
        }, (res) => {
            if (res?.success) {
                notifier.success(res?.message);
            }
        });
    }
}

export function saveOrDeleteOrganizationFromFavorites(organizationId) {
    const location = routes.lk.abitur.favoriteOrganizations.addOrDelete();
    const send = sendRequest('post', `${location}`, {
        _token: $('meta[name="csrf-token"]').attr('content'),
        organizationId,
    });
    return send;
}

export async function addDeleteFavorites(organizationId, isLogged = false) {
    // return 1 if add, 0 - delete
    let isAdd = 1;
    if (isLogged) {
        const response = await saveOrDeleteOrganizationFromFavorites(organizationId);
        isAdd = response.isAdd;
    } else {
        const store = new LocalStorage();
        const keyForStore = `favoriteOrganization${organizationId}`;
        const storeOrganizationId = store.get(keyForStore);
        if (storeOrganizationId === null) {
            store.set(keyForStore, '');
        } else {
            const neighboringElement = $('.favorite[data-id="' + organizationId + '"]').prev('.tooltip-text');
            neighboringElement.text('в избранное');
            store.remove(keyForStore);
            isAdd = 0;
        }
    }
    return isAdd;
}

export function checkOrganizationInFavoriteList(organizationId) {
    const store = new LocalStorage();
    const keyForStore = `favoriteOrganization${organizationId}`;
    const storeOrganizationId = store.get(keyForStore);
    if (storeOrganizationId == null) {
        return 0;
    }
    return 1;
}

function changeFavoriteElement($element, isAdd, dataId) {
    const image_star = $('.favorite[data-id="' + dataId + '"]');
    if (isAdd) {
        const neighboringElement = $('.favorite[data-id="' + dataId + '"]').prev('.tooltip-text');
        neighboringElement.text('убрать из избранного');
        image_star.addClass('favorite_purple');
    } else {
        image_star.removeClass('favorite_purple');
    }
}
